<template>
  <el-config-provider :locale="elLocale.value">
    <div id="app" class="container">
      <!--@mouseover="handleMouseMonitor"-->
      <!--:title="$t('HOME.TITLE')"-->
      <van-nav-bar
        v-if="objBaseInfo.channelId === 'MOBILE'"
        title=""
        left-arrow
        @click-left="onClickLeft"
        fixed
        placeholder
        safe-area-inset-top
        z-index="1"
      >
        <template #right>
          <!-- <button class="btn-icon" v-on:click="handleLanguage2" title="">
            <svg-icon :icon-class="lanageIcon"></svg-icon>
          </button> -->
          <svg-icon icon-class="ic_home" class="showmap_icon_style" @click="onClickRight"></svg-icon>
        </template>
      </van-nav-bar>
      <Loading :loading="menuAllloading" />
      <!-- begin:: Header -->
      <Header v-if="isDirectAccess && objBaseInfo.channelId === 'WEB'" />
      <!-- end:: Header -->
      <router-view />
      <!-- begin:: Footer -->
      <Footer v-if="isDirectAccess && objBaseInfo.channelId === 'WEB'" />
      <!-- end:: Footer -->
    </div>
  </el-config-provider>
</template>
<script>
import { getCurrentInstance , ref} from 'vue';
// @ is an alias to /src
import Header from "@/components/layout/header.vue";
import Footer from "@/components/layout/footer.vue";
import Loading from "@/components/Loading.vue";
import "@/assets/stylus/global.styl";
import "@/assets/stylus/fonts.styl";
import "@/assets/stylus/elementui.styl";
// import { checkSession, userLoginOut } from "@/api/platformData";
import BaiduMap from "@/plugins/map.js";
import { Locale } from "vant";
import { jumpLogin } from "@/api/platformData.js";
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Loading,
  },
  provide() {
    return {
      elLocale: this.elLocale
    };
  },
  data() {
    return {
      isDirectAccess: true,
      lastMovementTime: new Date().getTime(),
      startActiveTiem: new Date().getTime(),
      menuAllloading: false,
      lanageIcon: "lang-zh",
      preRouteName: "",
      currRouteName: "",
      objBaseInfo: {}, // 存储全局属性
      elLocale: ref(zhCn) // Element Plus 语言包
    };
  },
  created() {
    // 获取全局属性
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
    }
    
    if (this.objBaseInfo.channelId === "MOBILE") {
      this.lanageIcon = this.$i18n.locale == "en" ? "lang-en" : "lang-zh";
    }
    let lang = localStorage.getItem("language");
    this.elLocale.value = lang === "en" ? en : zhCn;
  },
  methods: {
    async getCWTH5() {
      this.menuAllloading = true;
      let jumpParams = {
        params: {
          jumpType: this.objBaseInfo.jumpType,
          menuFunCode: "menuFL01",
        },
      };
      await jumpLogin(jumpParams)
        .then((res) => {
          this.menuAllloading = false;
          if (res.code == 200) {
            window.location.href = res.data;
          } else {
            console.log("OBT菜单转sso跳转失败", res);
          }
        })
        .catch((err) => {
          this.menuAllloading = false;
          console.log("OBT菜单转sso跳转失败", err.objError);
        });
    },
    /**
     * 鼠标悬浮时触发，检测页面是否操作
     */
    // handleMouseMonitor() {
    //   //重置时间
    //   this.lastMovementTime = new Date().getTime();
    // },
    //清空session
    clearSession() {
      if (sessionStorage.getItem("createOrder")) {
        sessionStorage.removeItem("createOrder");
      }
      if (sessionStorage.getItem("createGuarantee")) {
        sessionStorage.removeItem("createGuarantee");
      }
    },
    onClickLeft() {
      switch (this.currRouteName) {
        case "Result":
          this.$router.push({
            name: "Home",
            query: this.$store.state.pathQuery,
          });
          break;
        case "Detail":
          if (this.preRouteName == "MapResultMobile") {
            this.$router.push({
              name: "Result",
              query: this.$store.state.pathQuery,
            });
          } else {
            this.$router.push({
              name: this.preRouteName,
              query: this.$store.state.pathQuery,
            });
          }
          break;
        case "MapHotelListMobile":
          this.$router.push({
            name: "Home",
            query: this.$store.state.pathQuery,
          });
          break;
        case "MapResultMobile":
          this.$router.push({
            name: "Detail",
            query: this.$store.state.pathQuery,
          });
          break;
        case "Home":
          this.getCWTH5();
          break;
        default:
          history.go(-1);
          break;
      }
    },
    onClickRight() {
      //调到CWT手机端首页
      // location.href="";
      if (this.currRouteName && this.currRouteName != "Home") {
        this.$router.push({ name: "Home" });
      } else {
        this.getCWTH5();
      }
    },
    // handleLanguage2: function (event) {
    //   let locale = this.$i18n.locale;
    //   if (locale === "en") {
    //     event.target.setAttribute("xlink:href", "#icon-lang-zh");
    //     localStorage.setItem("language", "zh");
    //     this.$i18n.locale = "zh";
    //   } else {
    //     event.target.setAttribute("xlink:href", "#icon-lang-en");
    //     localStorage.setItem("language", "en");
    //     this.$i18n.locale = "en";
    //   }
    //   Locale.use(this.$i18n.locale, this.$i18n.messages[this.$i18n.locale]);
    // },
  },
  beforeCreate() {
    //加载高德地图
    BaiduMap.initAMap();
    // if (sessionStorage.getItem('AdStatus') == null) {
    //   sessionStorage.setItem("AdStatus", "0");
    // } 
    // // 在全局对象 window 上定义一个 userData 变量
    // window.userData = { UserId: this.objBaseInfo.loginID, CustomerId: this.objBaseInfo.customerCode, CustomerName:this.objBaseInfo.customerName};
    // //登录后先检测session是否失效
    // this.lastMovementTime = new Date().getTime();
    // this.startActiveTiem = new Date().getTime();
    // checkSession()
    //   .then((res) => {
    //     if (res.code !== 200) {
    //       location.href = res.data;
    //     }
    //   })
    //   .catch(function (error) {
    //     console.log("check session 请求失败", error);
    //   });
  },
  mounted() {
    document.getElementById('mainLoading').style.display = 'none';
  },
  // mounted() {
  //   //每1秒检测一次是否超过20分钟未操作
  //   // let $this = this;
  //   // window.setInterval(() => {
  //   //   let currentTime = new Date().getTime();
  //   //   let timeOut = 20 * 60 * 1000; //20分钟后端session过期,参数: 20*60*1000
  //   //   if (currentTime - $this.lastMovementTime < timeOut) {
  //   //     if (currentTime - $this.startActiveTiem >= 4 * 60 * 1000) { //有效期内激活一次
  //   //       $this.startActiveTiem = new Date().getTime();
  //   //       //延长 session 时间
  //   //       checkSession()
  //   //         .then((res) => {
  //   //           if (res.code !== 200) {
  //   //             location.href = res.data;
  //   //           }
  //   //         })
  //   //         .catch(function (error) {
  //   //           console.log("check session 请求失败", error);
  //   //         });
  //   //     }
  //   //   } else { //20分钟未操作页面设置session失效
  //   //     userLoginOut()
  //   //       .then((res) => {
  //   //         if (res.code == 200) {
  //   //           location.href = res.data;
  //   //         } else {
  //   //           console.log("退出 请求失败, code:" + res.code, res.message);
  //   //         }
  //   //       })
  //   //       .catch((error) => {
  //   //         console.log("退出 请求失败", error);
  //   //       });
  //   //   }
  //   // }, 1000);
  // },
  watch: {
    //判断来源：CRM、OBT跳转过来隐藏头尾
    $route: {
      immediate: true,
      handler(newRouteName, oldRouteName) {
        this.preRouteName = oldRouteName ? oldRouteName.name : "";
        this.currRouteName = newRouteName.name;
        if (newRouteName.query.sourceType == "CRM") {
          //不是直接访问时隐藏页头页尾
          this.isDirectAccess = false;
        } else if (newRouteName.query.sourceType == "OBT") {
          if (newRouteName.name == "orderList") {
            this.isDirectAccess = false;
          }
        }
        if (
          newRouteName.name == "Home" ||
          newRouteName.name == "Result" ||
          newRouteName.name == "Detail"
        ) {
          this.clearSession();
        }
      },
    },
  },
};
</script>
<style lang="stylus" scoped>
.container {
  height: 100%;
}
.btn-icon {
  border: 0;
  margin-right: 3rem;
  line-height: 1rem;
}
:deep(.van-nav-bar--fixed) {
  border-bottom: 1px solid #fc6640;
}
:deep(.van-nav-bar .van-icon) {
  color: #333F48;
}
</style>
<style>
  body {
    letter-spacing: 0.05em;
  }
</style>